import Reports_PortfolioBalancerReportPage from "@Reports/Reports/Pages/PortfolioBalancerReportPage.vue";
import Reports_ReportsPage from "@Reports/Reports/Pages/ReportsPage.vue";

export const routes = [

    //Manage reports
    { path: "/portfolio/reports/:workspaceId/:projectId", component: Reports_ReportsPage },
    { path: "/decision/reports/:workspaceId/:projectId", component: Reports_ReportsPage },

    //View report
    { path: "/portfolio/reportview/pb/:workspaceId/:projectId/:reportId", component: Reports_PortfolioBalancerReportPage },
    { path: "/decision/reportview/pb/:workspaceId/:projectId/:reportId", component: Reports_PortfolioBalancerReportPage },
]
